import PropTypes from "prop-types";
import React, { useState } from "react";
import { submitRequestForm } from "../../../../redux/Actions/NipOnboardingActions";
import UpdateForm from "../Nip-Permit-Form/UpdateForm";
import UpdateKeys from "./UpdateKeys";
import { connect } from "react-redux";

const UpdateIpForm = (props) => {
  const { application, isSubmitting, submitApplication } = props;

  const [showIp, setShowIp] = useState(true);

  const [state, setState] = useState({
    uploaded: false,
    public_key_url: "",
    error: "",
  });

  return (
    <div>
      {showIp ? (
        <UpdateForm
          setShowIp={() => setShowIp(false)}
          application={application}
        />
      ) : (
        <UpdateKeys
          application={application}
          isSubmitting={isSubmitting}
          submitApplication={submitApplication}
          state={state}
          setState={setState}
        />
      )}
    </div>
  );
};

UpdateIpForm.propTypes = {
  application: PropTypes.any,
  isSubmitting: PropTypes.any,
  submitApplication: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    isSubmitting: state.nipOnboarding.isSubmittingRequestForm,
  };
};

const mapDispatchToProps = (dispatch) => ({
  submitApplication: (payload, type) =>
    dispatch(submitRequestForm(payload, type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateIpForm);
